import React from "react";
import { FaCheck } from "react-icons/fa";
import { MdOutlineCurrencyExchange } from "react-icons/md";

function WeDeliver() {
  const services = [
    "Custom UI/UX design tailored to your brand",
    "Multi-asset trading engine with real-time order matching",
    "Advanced security with 2FA, DDoS protection & cold storage",
    "Integrated liquidity management solutions",
    "Scalable microservices architecture",
    "Regulatory compliance and KYC/AML integration",
  ];

  return (
    <div style={{ padding: "80px 0", background: "#fff" }}>
      <div className="container">
        <div className="row align-items-center g-5">
          <div className="col-lg-6">
            <div
              className="ce-deliver-img text-center d-flex align-items-center justify-content-center"
              // style={{ minHeight: "350px" }}
            >
              <img
                src="assets/img/thumb/we_deliver_the_best_crypto.svg"
                style={{ width: "70%" }}
              />
            </div>
          </div>
          <div className="col-lg-6">
            <h2
              className="fw-bold mb-3"
              style={{ color: "#0a1f44", fontSize: "clamp(22px, 2.5vw, 36px)" }}
            >
              We Deliver the Best Crypto Exchange Development Services
            </h2>
            <p className="text-muted mb-4" style={{ lineHeight: "1.8" }}>
              As a leading cryptocurrency exchange development company, Xeer
              Technology builds feature-rich, highly secure, and scalable
              exchange platforms that are ready for global markets.
            </p>
            <ul className="list-unstyled">
              {services.map((item, idx) => (
                <li key={idx} className="d-flex align-items-start gap-3 mb-3">
                  <div className="ce-check-icon d-flex align-items-center justify-content-center">
                    <FaCheck size={14} />
                  </div>
                  <span style={{ color: "#334155", fontSize: "15px" }}>
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WeDeliver;
